import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  createField,
  createValidateObject,
  getForm,
  storeSetFieldsErrors,
  storeSetFieldValue
} from '../../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../../utils/reducerHalpers/requestState';
import { getItemFromRefList } from '../../../../../main/reducers/static/states/referenceLists/reducer';

const INIT_STATE = 'INIT_STATE';
const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_REQUEST = 'SEND_REQUEST';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
const CHANGE_FIELD_FEEDBACK_TOPICS_ID = 'CHANGE_FIELD_FEEDBACK_TOPICS_ID';
const CHANGE_FIELD_CUSTOM_TOPIC = 'CHANGE_FIELD_CUSTOM_TOPIC';
const CHANGE_FIELD_CONTENT = 'CHANGE_FIELD_CONTENT';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        ...createField({
          field: 'feedback_topics_id',
          title: 'Тема сообщения',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }),
        ...createField({
          field: 'custom_topic',
          title: 'Своя тема сообщения',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }),
        ...createField({
          field: 'content',
          title: 'Сообщение',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        })
      }
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_IN_PROGRESS):
        return setRequestStateInProgress(state);
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, SEND_REQUEST):
        return state;
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state.merge({
          errors: {}
        });

      // FIELDS
      case createActionName(name, CHANGE_FIELD_FEEDBACK_TOPICS_ID): {
        return storeSetFieldValue(state, 'feedback_topics_id', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_CUSTOM_TOPIC): {
        return storeSetFieldValue(state, 'custom_topic', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_CONTENT): {
        return storeSetFieldValue(state, 'content', action.payload);
      }
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequest = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST),
  payload
});
export const setErrors = (parentName, payload) => ({
  type: createActionName(parentName, SET_ERRORS),
  payload
});
export const clearAllErrors = (parentName, payload) => ({
  type: createActionName(parentName, CLEAR_ALL_ERRORS),
  payload
});

export const changeFieldFeedbackTopicsId = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_FEEDBACK_TOPICS_ID),
  payload
});
export const changeFieldCustomTopic = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_CUSTOM_TOPIC),
  payload
});
export const changeFieldContent = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_CONTENT),
  payload
});

// SELECTORS
export const selectFormBody = (state, parentName) =>
  getForm(getState(state, parentName));
export const selectRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestState');
export const selectFieldFeedbackTopicsId = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.feedback_topics_id');
export const selectFieldCustomTopic = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.custom_topic');
export const selectFieldContent = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.content');

export const selectFeedbackTopics = state =>
  getItemFromRefList(state, 'feedbackTopics');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/feedback/reducers/static/forms/sendFeedback/sendFeedbackForm.js